var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4f3xcgbx7a",
    d: "M0.704 0.477L9.509 0.477 9.509 12.6 0.704 12.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M8.805 0L8.805 12.177 17.609 12.177 17.609 4.467zM0 12.177v1.033C0 20.065 8.805 24.3 8.805 24.3V12.177H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M8.805 0L0 4.467 0 12.177 8.805 12.177z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.1 11.7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fha7azhyvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4f3xcgbx7a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M.704 12.6S9.51 8.366 9.51 1.51V.477H.704V12.6z",
    mask: "url(#fha7azhyvb)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.ba54e11067eaa10e2da19a6acbb17559.svg";
export { ForwardRef as ReactComponent };